export default __webpack_public_path__ + "static/media/763.725a00a8.png";